import {apiStyle} from '@infra/api/rest/domain/model/Style/apiStyle';
import {Segment} from '@lookiero/quiz';

import {FillBirthdateCommand} from '@domain/model/Style/StyleRepository';
import {getAuthHeader} from '@infra/api/authManager/authManager';
import {fetch} from '@infra/api/fetch';
import {DEFAULT_HEADERS} from '../_utils/defaultHeaders';

const FILL_BIRTHDATE_URL = '/style-profile/api/fill-birthdate';

const fillBirthdate = async (command: FillBirthdateCommand): Promise<void> => {
  const authHeader = await getAuthHeader();
  const result = await fetch(FILL_BIRTHDATE_URL, {
    method: 'POST',
    headers: {...authHeader, ...DEFAULT_HEADERS},
    body: JSON.stringify(command),
  });

  if (!result.ok) return Promise.reject(new Error('Failed to fill birthdate'));
};

const getQuizId = (): Promise<string> => {
  return apiStyle.getQuizId();
};

const deleteQuizId = (): Promise<void> => {
  return apiStyle.deleteQuizId();
};

const getQuizSegment = async (): Promise<Segment> => await apiStyle.getQuizSegment();
const deleteQuizSegment = async (): Promise<void> => await apiStyle.deleteQuizSegment();
const getCustomerId = async (): Promise<string | null> => await apiStyle.getCustomerId();
const deleteCustomerId = async (): Promise<void> => await apiStyle.deleteCustomerId();

export const ApiStyleRepository = {
  getQuizId,
  deleteQuizId,
  getQuizSegment,
  deleteQuizSegment,
  getCustomerId,
  deleteCustomerId,
  fillBirthdate,
};
